const config = {
    'SERVICE_URL_PREFIX': 'http://localhost:8081/api/v1',
}

export default config;